<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">
                            Digitalne karte ({{ totalRecords }})
                            <template v-if="filter.ticketStatus === null || filter.ticketStatus === undefined">
                                — Naplaćeno: {{ totalPaid }} EUR / Stornirano: {{ totalStorno }} EUR
                            </template>
                            <template v-else>
                                ({{ totalPrice }} EUR)
                            </template>
                        </h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" format="dd.MM.yyyy. HH:mm:ss"
                                    value-format="timestamp" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.ticketStatus" class="select-primary" name="zone" clearable
                                    @clear="filter.ticketStatus = null">
                                    <el-option v-for="zone in ticketStatuses" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Tip</h4>
                            <base-input>
                                <el-select v-model="filter.ticketType" class="select-primary" name="zone" clearable
                                    @clear="filter.ticketType = null">
                                    <el-option v-for="zone in ticketTypes" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Zona</h4>
                            <base-input>
                                <el-select v-model="filter.clientId" class="select-primary" name="zone" clearable>
                                    <el-option v-for="zone in zones" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Grupa</h4>
                            <el-select v-model="filter.kioskGroup" class="select-primary" value-key="id"
                                name="kioskGroups" clearable @change="getKiosks()">
                                <el-option v-for="t in kioskGroups" class="select-primary" :label="t.name" :value="t"
                                    :key="t.id"></el-option>
                            </el-select>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kiosk</h4>
                            <base-input>
                                <el-select v-model="filter.kioskId" class="select-primary" name="zone"
                                    v-loading="kiosksLoading" clearable>
                                    <el-option v-for="zone in kiosks" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getTickets()">Pretraži</base-button>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getReport()">Izvestaj</base-button>
                        </div>
                    </div>
                    <el-table :data="tickets" v-loading="ticketsLoading">
                        <el-table-column min-width="130" prop="stamp" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span>{{ scope.row.client?.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="kiosk" label="Kiosk">
                            <template slot-scope="scope">
                                <span>{{ scope.row.kiosk?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="price" label="Cena">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>


                        <el-table-column min-width="80" prop="price" label="Količina (Sati/Dani)">
                            <template slot-scope="scope">
                                <span>{{ scope.row.count }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="ticketStatus" label="Tip">
                            <template slot-scope="scope">
                                <span v-if="scope.row.day" style="color: aqua;">DNEVNA KARTA</span>
                                <span v-else style="color: cadetblue;">OBIČNA KARTA</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="ticketStatus" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ticketStatus === 0">NAPLAĆENA</span>
                                <span v-if="scope.row.ticketStatus === 1" style="color: red;">STORNIRANA</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button v-if="scope.row.ticketStatus === 0" :type="'danger'" class="btn-link"
                                    @click="stornoTicketPrompt(scope.row)">
                                    Storniranje
                                </base-button>
                                <base-button :type="'success'" class="btn-link" @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>

                            </div>
                        </el-table-column>

                    </el-table>
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false; ticket = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card>

                        Tablice: {{ ticket.plates }}<br>
                        <template v-if="ticket.ticketStatus === 0">
                            Broj karte: {{ ticket.plateParking?.ticketNumber }}<br>
                            Važi do: {{ (new Date(ticket.plateParking?.stampEndLong)).toLocaleString("de-DE") }}<br>
                        </template>
                        <template v-else>
                            Stornirano: {{ (new Date(ticket.stornedStampLong)).toLocaleString("de-DE") }}<br>
                        </template>
                        Uplaćeno: {{ (new Date(ticket.stampLong)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;<br>
                        Zona: {{ ticket.client?.name }}<br>
                        <span v-if="ticket.day" style="color: aqua;">DNEVNA KARTA</span>
                        <span v-else style="color: cadetblue;">OBIČNA KARTA</span>
                    </card>
                </div>

            </div>



        </modal>

    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb, BasePagination } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const ticketStatuses = [
    { id: 0, name: 'NAPLAĆENA' },
    { id: 1, name: 'STORNIRANA' }
]

const ticketTypes = [
    { id: 0, name: 'DNEVNA KARTA' },
    { id: 1, name: 'OBIČNA KARTA' }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        BasePagination,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getUserPageFilter()
        this.getZones()
        this.getKiosks()
        this.getKioskGroups()
        // this.getPaymentStatuses()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            ticketStatuses,
            ticketTypes,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            ticketsLoading: false,
            loading: false,
            tickets: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                ticketNumber: null,
                plates: null,
                countryMark: null,
                kioskId: null,
                paymentStatusId: null,
                clientId: null,
                kioskGroup: null,
                ticketStatus: null,
                ticketType: null
            },
            employees: [],
            paymentStatuses: [],
            zones: [],
            ticketsLoading: false,
            ticket: {},
            showTicket: false,
            image: null,
            showImage: false,
            thicketHistory: [],
            showTicketHistory: false,
            kiosks: [],
            kioskGroups: [],
            kiosksLoading: false,
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            sortField: "stamp",
            sortOrder: "descending",
            totalPrice: 0,
            totalPaid: 0,
            totalStorno: 0,
            ticket: {},
            showTicket: false
        };
    },
    methods: {
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        getUserPageFilter() {
            this.loading = true

            axios.get(this.url + '/settings/getUserPageFilter?page=4').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                } else {
                    // this.$notify({
                    //     message:
                    //         result.data.reason,
                    //     timeout: 3000,
                    //     icon: 'tim-icons icon-bell-55',
                    //     horizontalAlign: "right",
                    //     verticalAlign: "top",
                    //     type: 'danger'
                    // });
                }
                this.getTickets()
            })
        },
        getTicket(t) {
            this.loading = true

            axios.get(this.url + '/kiosk/getTicket?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket
                    this.showTicket = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getKioskGroups() {
            axios.get(this.url + '/kiosk/getKioskGroups').then(result => {

                if (result.data.result === 'ok') {
                    this.kioskGroups = result.data.kioskGroups
                } else {

                }
            })
        },
        saveTicket() {
            this.loading = true
            axios.post(this.url + '/ticket/cancelTicket', this.ticket).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });

                    this.getTickets()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getTIcketHistory() {
            this.loading = true
            axios.get(this.url + '/ticket/getTicketHistory?ticketId=' + this.ticket.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.thicketHistory = result.data.history
                    this.showTicketHistory = true
                } else {

                }
            })
        },
        getZones() {
            // this.zonesLoading = true
            axios.get(this.url + '/client/getClients').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                } else {

                }
            })
        },
        getPaymentStatuses() {
            // this.zonesLoading = true
            axios.get(this.url + '/settings/getPaymentStatuses').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.paymentStatuses = result.data.paymentStatuses
                } else {

                }
            })
        },
        getKiosks() {
            this.kiosksLoading = true
            const filter = {
                kioskGroup: this.filter.kioskGroup
            }
            axios.post(this.url + '/kiosk/getKiosks', filter).then(result => {
                this.kiosksLoading = false

                if (result.data.result === 'ok') {
                    this.kiosks = result.data.kiosks
                } else {

                }
            })
        },
        stornoTicket(ticket) {
            this.loading = true

            axios.post(this.url + '/kiosk/stornoTicket', ticket).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.getTickets()
                } else {

                }
            })
        },
        getTickets() {
            this.loading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            f.sortField = this.sortField
            f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/kiosk/getTickets', f).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                    this.totalPaid = result.data.totalPaid
                    this.totalStorno = result.data.totalStorno
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getReport() {
            this.loading = true
            const f = this.filter
            // f.page = this.page
            // f.max = this.max
            // f.sortField = this.sortField
            // f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/kiosk/getFrontReport', f).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    if (result.data.fileName) {

                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;

                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        navigateToPage() {
            this.$router.push({ name: 'Administration' });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da parking mesto \"" + this.parkingSpace.number + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteParkingSpace()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        stornoTicketPrompt(ticket) {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da stornirate kartu ?",
                    text: ``,
                    confirmButtonText: "Da, storniraj!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.stornoTicket(ticket)
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        saveTicketPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar za ovu promenu.",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.ticket.comment = comment;
                        this.saveTicket()
                    }
                });
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>